import React from "react";
import { colors2, SwitchSingle, UI_BODY_SM } from "oolib";
import { DataFieldInputSelector } from "@/components/DataFieldInputSelector";
import TooltipV2 from "@/components/UI/Tooltip";
import { CollapseTransition } from "./CollapseTransition";

// On/off options for the SwitchSingle. Display strings are empty because the
// row's own label carries the meaning.
const SWITCH_OPTIONS = [
  { display: "", value: false },
  { display: "", value: true },
];

/**
 * A labelled on/off row in the config form's grey-card style. Passing
 * disabledTooltip locks the row and explains why on hover.
 */
export const SwitchRow = ({ id, label, value, onChange, disabledTooltip }) => {
  const disabled = !!disabledTooltip;
  const row = (
    <div
      onClick={disabled ? undefined : () => onChange(!value)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "1rem",
        background: "#F7F7F7",
        borderRadius: "6px",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <UI_BODY_SM style={{ color: disabled ? colors2.grey40 : colors2.grey80 }}>{label}</UI_BODY_SM>
      <SwitchSingle
        id={id}
        option={SWITCH_OPTIONS[1]}
        value={value ? SWITCH_OPTIONS[1] : undefined}
        onChange={(_, newVal) => onChange(newVal?.value === true)}
        layoutStyle="style2"
        disabled={disabled}
      />
    </div>
  );
  return disabled ? (
    <TooltipV2 text={disabledTooltip} placement="top">
      {row}
    </TooltipV2>
  ) : row;
};

/**
 * The "combine into Others" switch plus its count stepper, shared by the pie and
 * bar chart config forms. Pair it with useCombineSegments, which owns the state.
 *
 * Naming is per-chart — the pie combines "segments", the bar combines "bars" —
 * so both labels are props.
 */
export const CombineSegmentsControl = ({
  label,
  countLabel,
  combine,
  setCombine,
  count,
  setCount,
  min,
  max,
}) => (
  <>
    <SwitchRow id="combineSegments" label={label} value={combine} onChange={setCombine} />

    <CollapseTransition isVisible={combine}>
      <DataFieldInputSelector
        stepper={{ label: countLabel, value: count, onChange: setCount, min, max }}
      />
    </CollapseTransition>
  </>
);
